import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOpenidIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.3125 15.4621V16.8746C5.4625 16.5371 2.5 14.5121 2.5 12.0559C2.5 9.69336 5.2625 7.72461 8.91875 7.28711V8.70586C6.525 9.11836 4.76875 10.4621 4.76875 12.0559C4.76875 13.7434 6.725 15.1371 9.3125 15.4621ZM17.5 11.1565L17.1919 7.93336L16.02 8.58773C14.9288 7.93336 13.5394 7.47086 11.9925 7.28898V8.71023C12.8794 8.86898 13.6831 9.15023 14.3363 9.53023L13.1038 10.214L17.5 11.1565Z",
		fill: "#B2B2B2"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.5875 3.125V15.8187L9.3125 16.875V4.225L11.5875 3.125ZM11.5875 10.7562H11.5938V15.8187H11.5875V10.7562Z",
		fill: "#F7931F"
	})]
});
export default SvgOpenidIcon;
